import Capitalize from 'Lib/Capitalize'

export const CommentRespTransform = (data) => {
  return data.map(comment => {
    return Object.assign(comment, {
      author: comment.name
        ? Capitalize(comment.name)
        : Capitalize(comment.email),
      children: comment.children.map(child => {
        return Object.assign(child, {
          author: child.name
            ? Capitalize(child.name)
            : Capitalize(child.email)
        })
      })
    })
  })
}



// WEBPACK FOOTER //
// ./src/Transforms/Comment.js